import React from 'react';

import { useDetectIncognitoMode } from 'utils/hooks/useDetectIncognitoMode';

import type { ITariffCardReactModel } from '../types';

export function withDetectIncognitoMode(
  WrappedComponent: React.ComponentType<ITariffCardReactModel>,
) {
  return (props: ITariffCardReactModel) => {
    useDetectIncognitoMode();

    return <WrappedComponent {...props} />;
  };
}
